//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QFabricModal from "@/components/q-fabric-modal";

export default {
    name: "DeleteDialogue",
    components: {
        QFabricModal
    },
    props: [
        "multiple"
    ],
    data() {
        return {
            showModal: true,
            response: false
        };
    },
    methods: {
        actionsDlg() {
            this.showModal = false;
        },
        afterHide() {
            const resp = this.response;
            const mult = this.multiple;
            const reply = {
                response: resp,
                multiple: mult
            };
            this.$emit("response", reply);
        },
        respond(value) {
            this.response = value;
            this.showModal = false;
        }
    }
};
